<template>
    <div class="grcform">
        <GrcDB ref="GRCDB"></GrcDB>    
        <GrcDialog ref="Dialog"
            v-on:popupopened="SetPopupRef('Dialog')"
            v-on:popupclosed="SetPopupRef('')"
        ></GrcDialog>

        <div class="grc_fullwidth_lane" style="background-color:transparent;">
            <div class="grc_maincont_lane">
                <div class="maintitle" style="text-align:center; color:dodgerblue; display:none;"><i class="fas fa-calculator" style="margin-right:10px;"></i>{{title}}</div>
            </div>
        </div>

        <div class="grc_fullwidth_lane">
        <div class="grc_maincont_lane" style="padding:10px;">

            <div class="main_col_banner_top">
                <div class="main_col_banner_top_item">
                    <img src="../../../public/styles/images/bannerek/banner_20220830_1_kicsi.jpg" class="banner_img" @click="banner_click()" />
                </div>
                <div class="main_col_banner_top_item">
                    <img src="../../../public/styles/images/bannerek/banner_20220830_3_kicsi.jpg" class="banner_img" @click="banner_click()" />
                </div>
            </div>

            <div class="main_col_cont">
                <div class="main_col main_col_middle">
                        <div style="width:100%; box-sizing:border-box; font-size: 16px; line-height:20px; text-align:justify; margin-bottom: 10px; padding: 4px 0px; padding: 8px; border-radius: 8px; background-color: var(--premgreen); color: #fff; margin-top: 8px; background-color: #f0f1f2;    color: #222;    border: solid 1px #e0e0e0;    box-shadow: 0px 0px 15px 0px rgb(0 0 0 / 25%);    -webkit-box-shadow: 0px 0px 15px 0px rgb(0 0 0 / 25%);  margin: 10px auto;"  v-show="innerformid==1">
                        Töltsd ki kalkulátorunkat és megtudod, hogy az átalányadó vagy az általános szabályok szerinti adózással jársz jobban. 
                        Ha az SZJA számításhoz szükséges adatokat is megadod, az igénybevehető adókedvezményekkel is számolunk. 
                        <br><br><span style="font-weight:bold; color: #000;">Így tényleg megtudhatod, hogy az év végén, mennyi pénz maradhat a zsebedben.</span><br><br>
                        Fontos! A kalkulátor nem tárolja el a megadott adatokat!
                        </div>

                    <div class="innerform" style="padding:8px 16px;" v-show="innerformid==1">

                        <span class="field_label" style="display:block; box-sizing:border-box;">Státusz <span class="infobtn" @click="InfoBtnClick(0)"><i class="fas fa-info-circle"></i></span></span>
                        <GrcCombo ref="STATUSZ" v-model="StatuszID" grc_labeltext=""
                        grc_labelmode="nolabel" grc_labelwidth="0px" grc_dropdownminwidth="300" grc_dropdownheight="170"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('STATUSZ')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        style="margin-bottom:20px;"
                        />

                        <span class="field_label" style="display:block; box-sizing:border-box;">Középfokú végzettséget, szakképzettséget igénylő tevékenységet végzel? <span class="infobtn" @click="InfoBtnClick(1)"><i class="fas fa-info-circle"></i></span></span>
                        <GrcCombo ref="VEGZETTSEG" v-model="VegzettsegID" grc_labeltext=""
                        grc_labelmode="nolabel" grc_labelwidth="0px" grc_dropdownminwidth="300" grc_dropdownheight="150"  
                        grc_keyfield="id" grc_displayfield="Megnevezes"
                        v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                        v-on:dropdownopened="SetPopupRef('VEGZETTSEG')"
                        v-on:dropdownclosed="SetPopupRef('')"
                        v-on:grc-keydown-enter="SetControlToFocus('');"
                        style="margin-bottom:20px;"
                        />


                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Éves bevétel: <span class="infobtn" @click="InfoBtnClick(2)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtEvesBevetel" v-model="txtEvesBevetel"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Átalányköltség: <span class="infobtn" @click="InfoBtnClick(3)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcCombo ref="KOLTSEG" v-model="KoltsegID" grc_labeltext=""
                                    grc_labelmode="nolabel" grc_labelwidth="0px" grc_dropdownminwidth="120" grc_dropdownheight="120"  
                                    grc_keyfield="id" grc_displayfield="Megnevezes"
                                    v-bind:grc_dropdown_columns="[{fieldname:'Megnevezes', width:'100%', cutlongtext:'true'}]"
                                    v-on:dropdownopened="SetPopupRef('KOLTSEG')"
                                    v-on:dropdownclosed="SetPopupRef('')"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="margin-bottom:0px;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Várható összes költségem: <span class="infobtn" @click="InfoBtnClick(4)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtVarhatoKoltseg" v-model="txtVarhatoKoltseg"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Ebből anyag, áru és alvállalkozók költsége: <span class="infobtn" @click="InfoBtnClick(5)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtAnyagKoltseg" v-model="txtAnyagKoltseg"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <table style="width:100%; display:none;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Más forrásból származó jövedelem: <span class="infobtn" @click="InfoBtnClick(6)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcNum ref="txtMasForrasJovedelem" v-model="txtMasForrasJovedelem"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="100px"
                                    grc_currency="Ft" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>

                        <div style="width:100%; box-sizing:border-box; text-align:left; color:#222; font-size:16px; line-height:16px; padding:4px 0px; border-bottom:dotted 1px #ccc; font-weight:bold; margin-top:20px;">Adatok SZJA számításához:</div>
                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Születési dátum: <span class="infobtn" @click="InfoBtnClick(7)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input">
                                    <GrcDate ref="txtSzuletesiDatum" v-model="txtSzuletesiDatum" grc_dateformat="ymd" grc_sep="." 
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="200px" grc_readonly="false"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    v-on:dropdownopened="SetPopupRef('txtSzuletesiDatum')"
                                    v-on:dropdownclosed="SetPopupRef('')"
                                    style="margin-bottom:0px;"
                                    />

                                </td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><span class="field_label">Személyi kedvezmény: <span class="infobtn" @click="InfoBtnClick(8)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:40px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkSzemelyiKedvemzeny" /></td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Első házas kedvezmény: <span class="infobtn" @click="InfoBtnClick(9)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:40px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkElsoHazasKedvezmeny" /></td>
                            </tr>
                            <tr>
                                <td><span class="field_label">Családi adókedvezményt veszek igénybe: <span class="infobtn" @click="InfoBtnClick(10)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:40px; padding-left: 10px;"><GrcCheckboxMobile2 ref="chkCsaladiAdokedvezmeny" v-on:valuechanged="chkCsaladiAdokedvezmeny_click" /></td>
                            </tr>
                        </table>

                        <table style="width:100%;" cellspacing="0" cellpadding="0" v-show="IsChecked_chkCSAK">
                            <tr>
                                <td><span class="field_label" style="padding-left:30px;">Eltartott: <span class="infobtn" @click="InfoBtnClick(11)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:50px;">
                                    <GrcNum ref="txtEltartott" v-model="txtEltartott"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="50px"
                                    grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('txtKedvezmenyezettEltartott');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                            <tr>
                                <td><span class="field_label" style="padding-left:30px;">Kedvezményezett eltartott: <span class="infobtn" @click="InfoBtnClick(12)"><i class="fas fa-info-circle"></i></span></span></td>
                                <td class="field_input" style="width:50px;">
                                    <GrcNum ref="txtKedvezmenyezettEltartott" v-model="txtKedvezmenyezettEltartott"
                                    grc_labeltext="" grc_labelmode="nolabel" grc_labelwidth="50px"
                                    grc_currency="" grc_decimalplaces="0" grc_readonly="false"
                                    grc_textalign="right"
                                    v-on:grc-keydown-enter="SetControlToFocus('');"
                                    style="width:100%;"
                                    />
                                </td>
                            </tr>
                        </table>
                        
                        <div style="width:100%; box-sizing:border-box; font-size: 16px; line-height:20px; text-align:justify; color: #222; margin: 20px 0px; padding: 4px 0px;">
                        A kalkulátor egyszerűsítő feltételezésekkel - például havonta azonos összegű jövedelemszerzés - él, az adatok tájékoztató jellegűek. 
                        A kalkulátor egy teljes évre vonatkozó adatokat számol, a 2022-ben érvényes adókulcsok és minimálbér mellett. 
                        Nem számol az összevont adóalapba tartozó átalányban megállapított jövedelemre, illetve vállalkozói kivétre érvényesíthető 
                        négy vagy több gyermeket nevelő anyák kedvezményével. A személyi és családi kedvezményt úgy veszi figyelembe, mintha az az 
                        egész év folyamán fennállna és nem kerülne megosztásra más keresővel.
                        </div>



                            <div style="width:100%; box-sizing:border-box; margin-bottom:10px;">
                                <GrcText ref="EmailCim"
                                grc_labeltext="E-mail cím:*" grc_labelmode="above" grc_labelwidth="80px" 
                                />
                            </div>

                            <div style="width:100%; box-sizing:border-box; margin-bottom:10px;">
                                <GrcMobilszam ref="Mobil"
                                grc_labeltext="Mobil telefon (06-al kezdve):" grc_labelmode="above" grc_labelwidth="80px" 
                                />
                            </div>

                            <table style="width:100%; margin-top:20px; margin-bottom:20px;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td style="width:45px;" valign="top"><GrcCheckboxMobile2 ref="chkSend_Hozzajarulas" /></td>
                                <td valign="top" class="chkHozzajarulas">
                                    Hozzájárulok, hogy a PRÉMIUM Egészségpénztár (1138 Budapest, Dunavirág u. 2-6.) e-mail címem és telefonszámom 3 évig kezelje, 
                                    és azokra a pénztári előnyökről és a pénztárhoz való csatlakozási lehetőségekről tájékoztatókat juttasson el részemre. 
                                    Jelen önkéntesen tett hozzájáruló nyilatkozat bármikor visszavonható postai úton (1138 Budapest, Dunavirág u. 2-6.) 
                                    vagy a kapcsolat@premiumpenztarak.hu email címre küldött levél útján.
                                </td>
                            </tr>
                            </table>        






                        <div class="btn_cont">
                            <div class="btn" @click="btnSzamol_click">SZÁMOL</div>
                        </div>





                    </div>
                    <div class="innerform" style="padding:16px;" v-show="innerformid==2">

                        <div style="width:100%; box-sizing:border-box; text-align:justify; margin-bottom:10px;">
                            <b>Eredmény</b>
                            <br><br>
                            Ennyi pénzem marad az összes adó és járulék megfizetése után
                        </div>

                        <table style="width:100%;" cellspacing="0" cellpadding="0">
                            <tr v-for="(trsum, trsumindex) in TSUM" :key="trsumindex">
                                <td v-html="trsum.Szoveg" style="padding:8px 4px 8px 0px;"></td>
                                <td style="width:150px; text-align:right; padding-right:0px;" v-html="trsum.Ertek"></td>
                            </tr>
                        </table>

                        <table style="width:100%; margin:30px 0px;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><b>Átalányadó részletes számítása</b></td>
                                <td class="szabaly_info_ikon" @click="DisplaySzamitas(1)"><i class="fas fa-info-circle"></i></td>
                            </tr>
                        </table>

                        <table style="width:100%; margin:30px 0px;" cellspacing="0" cellpadding="0">
                            <tr>
                                <td><b>Általános szabályok részletes számítása</b></td>
                                <td class="szabaly_info_ikon" @click="DisplaySzamitas(2)"><i class="fas fa-info-circle"></i></td>
                            </tr>
                        </table>


                        <div style="width:100%; box-sizing:border-box; text-align:justify; margin:30px 0px; display:none;">
                            <b>Átalányadó részletes számítása</b>
                        </div>

                        <table style="width:100%; display:none;" cellspacing="0" cellpadding="0">
                            <tr v-for="(tr, index) in T1" :key="index">
                                <td v-html="tr.Szoveg" style="padding:8px 4px 8px 0px; border-bottom: dotted 1px #ccc;"></td>
                                <td style="width:150px; text-align:right; padding-right:0px; border-bottom: dotted 1px #ccc;" v-html="tr.Ertek"></td>
                            </tr>
                        </table>

                        <div style="width:100%; box-sizing:border-box; text-align:justify; margin:30px 0px; display:none;">
                            <b>Általános szabályok részletes számítása</b>
                        </div>


                        <table style="width:100%; display:none;" cellspacing="0" cellpadding="0">
                            <tr v-for="(tr2, index2) in T2" :key="index2">
                                <td v-html="tr2.Szoveg" style="padding:8px 4px 8px 0px; border-bottom: dotted 1px #ccc;"></td>
                                <td style="width:150px; text-align:right; padding-right:0px; border-bottom: dotted 1px #ccc;" v-html="tr2.Ertek"></td>
                            </tr>
                        </table>


                        <div style="width:100%; box-sizing:border-box; background-color: #f0f1f2; padding: 8px; border-radius: 8px; border: solid 1px #e0e0e0;" v-show="MaradtSZJA==1">
                            <div style="width:100%; box-sizing:border-box; text-align:justify; margin-bottom:10px;">
                                <b>Befizetendő személyi jövedelemadó:</b>
                            </div>

                            <table style="width:100%;" cellspacing="0" cellpadding="0">
                                <tr v-for="(trszja, trszjaindex) in TSZJA" :key="trszjaindex">
                                    <td v-html="trszja.Szoveg" style="padding:8px 4px 8px 0px;"></td>
                                    <td style="width:150px; text-align:right; padding-right:0px;" v-html="trszja.Ertek"></td>
                                </tr>
                            </table>

                            <div style="width:100%; box-sizing:border-box; font-size: 16px; line-height:20px; text-align:justify; border-bottom: dotted 0px #888; color: #222; margin-bottom: 10px; padding: 4px 0px;" v-html="SzjaInfoSzoveg">
                            </div>


                            <div style="width:100%; box-sizing:border-box; font-size: 16px; line-height:20px; text-align:justify; border-bottom: dotted 0px #888; color: #222; margin-bottom: 10px; padding: 4px 0px;">
                                A feltüntetett információk, adatok, feltételek nem minősülnek nyilvános ajánlattételnek, kizárólag tájékoztatásul, a figyelem felhívására szolgálnak, azok teljességéért, pontosságáért a PRÉMIUM Egészségpénztár felelősséget nem vállal.
                            </div>

                        </div>

                        <div style="width:100%; box-sizing:border-box; font-size: 18px; line-height:24px; text-align:center; border-bottom: dotted 0px #888; color: #222; margin-bottom: 10px; padding: 4px 0px;">
                        Kérünk az 1 perces kérdőívünk kitöltésével segítsd munkánkat.
                        </div>


                        <div class="btn_cont">
                            <div class="btn" @click="btnKerdoiv_click">TOVÁBB A KÉRDŐÍVRE</div>
                            <div class="btn btn_gray2" @click="btnVissza_click">VISSZA</div>
                        </div>


                    </div>

                    <div class="innerform" style="padding:16px;" v-show="innerformid==3">

                        <div style="width:100%; box-sizing:border-box; font-size: 18px; line-height:24px; text-align:center; border-bottom: dotted 0px #888; color: #222; margin-bottom: 10px; padding: 4px 0px;">
                        Köszönjük, rögzítettük kapcsolattartási adataidat.<br>Kollégánk hamarosan jelentkezni fog.
                        <br><br>Kérünk az 1 perces kérdőívünk kitöltésével segítsd munkánkat.
                        </div>

                        <div class="btn_cont">
                            <div class="btn" @click="btnKerdoiv_click">Tovább a kérdőívre</div>
                        </div>


                    </div>


                </div>
                <div class="main_col main_col_right">
                    <img src="../../../public/styles/images/bannerek/banner_20220830_1.jpg" class="banner_img" @click="banner_click()" />
                    <img src="../../../public/styles/images/bannerek/banner_20220830_2.jpg" class="banner_img" @click="banner_click()" />
                </div>
            </div>
            





        </div>
        </div>
    </div>
</template>

<script>

import axios from "axios";
import GrcButton from '../GrcComponents/GrcButton.vue'
import GrcDB from '../GrcComponents/GrcDB.vue'
import GrcDialog from '../GrcComponents/GrcDialog.vue'
import GrcCombo from '../GrcComponents/GrcCombo.vue'
import GrcText from '../GrcComponents/GrcText.vue'
import GrcDate from '../GrcComponents/GrcDate.vue'
import GrcNum from '../GrcComponents/GrcNum.vue'
import GrcAdoazon from '../GrcComponents/GrcAdoazon.vue'
import GrcCheckboxMobile2 from '../GrcComponents/GrcCheckboxMobile2.vue'
import GrcMobilszam from '../GrcComponents/GrcMobilszam.vue'


export default {
  name: 'frmKalkulator',
  components: {
      GrcButton,
      GrcDB,
      GrcDialog,
      GrcCombo,
      GrcText,
      GrcDate,
      GrcNum,
      GrcAdoazon,
      GrcCheckboxMobile2,
      GrcMobilszam,
  },
  props: {
  },
  data () {
      return {
            WSPREFIX: "frmKalkulator",
            gPopupControlName:"",

            innerformid:1,
            title:"",

            STATUSZOK:[],
            VEGZETTSEG:[],

            StatuszID:0,
            VegzettsegID:0,
            txtEvesBevetel:0,
            KoltsegID:0,
            txtVarhatoKoltseg:0,
            txtAnyagKoltseg:0,
            txtMasForrasJovedelem:0,
            txtSzuletesiDatum:"",

            txtEltartott:0,
            txtKedvezmenyezettEltartott:0,
            IsChecked_chkCSAK:false,


            T1:[],
            T2:[],
            TSUM:[],
            TSZJA:[],

            MaradtSZJA:0,
            SzjaInfoSzoveg:"",


            INFOLIST:[
                `<b>Vállalkozói státusz</b>
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>36 órás munkaviszony / tanulmányok mellett</span>
                <br>
                máshol heti 36 órát meghaladó jogviszony (gyakorlatilag a 8 órás főállás) vagy nappali tagozatos hallgatói jogviszony
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>Nyugdíjas</span>
                <br>
                öregségi nyugdíjas (kizárólag öregségi nyugdíjkorhatárt betöltöttek vagy a „nők 40 évével” nyugdíjba vonultak)
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>Főállású vállalkozó</span>
                <br>
                minden egyéb esetben főállású vállalkozó
                <br><br>
                `,
                "Kattints a cellába és válassz a lehetőségek közül! Ha futár vagy akkor 'nem', szinte minden más estben 'igen'",
                "<b>Éves bevétel</b><br><br>Ennyit fogok várhatóan kiszámlázni 2023-ban.",
                `<b>Átalányköltség</b>
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>80%</span>
                <br>
                Az Szja tv. 53. § (2)* bekezdésében meghatározott ipari, mezőgazdasági, szolgáltatási tevékenység, vagy kizárólag a (2)* bekezdésben meghatározott és a c) pont szerinti kiskereskedelmi tevékenység (pl. építőipari szolgáltatás, fodrászat, szépségápolás, gépjármű-, számítógép-, háztartásicikk-javítás, vendéglátó tevékenység)
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>90%</span>
                <br>
                Kizárólag kiskereskedelmi tevékenység
                <br><br>
                <span style='font-weight:bold; color:dodgerblue;'>40%</span>
                <br>
                Minden a a 80 és 90%-os kategóriába nem tartozó esetben
                <br><br>
                `,
                "<b>Várható összes költség</b><br><br>Ha nem átalányadózó lennél, hanem az általános szabályok szerint adóznál, akkor ennyi számlával igazolt költséged lenne.",
                "<b>Anyag, áru és alvállalkozók költsége</b><br><br>Ha pl. gyártással foglalkozol, akkor ide tartozik az alapanyag, amiből elkészíted a terméket, vagy a csomagolóanyag, de a szerszámaid is, feltéve hogy nem minősülnek tárgyi eszköznek. Ha valamilyen szolgáltatást nyújtasz, akkor a tisztítószerek és irodaszerek is ide sorolhatóak. Ha kereskedő vagy ide számít az áru amit beszereztél és ugyanolyan formában továbbértékesítesz. Ha kiszervezed a munkát, tehát a vevő felé az adott dolgot csak továbbszámlázod, az árréssel növelten szintén ide tartozik.",
                "Más forrásból származó, az osztalékalap utáni szocho maximális értékének számításakor figyelembe vett jövedelem (pl. bér, osztalék, árfolyamnyereség stb.)",
                "A születési dátumod megadására azért van szükség, hogy meg tudjuk határozni a 25 év alattiak adókedvezményét.",
                "Súlyos, krónikus betegségben szenvedők kedvezménye. <br>További info: <a href='https://nav.gov.hu/nav/ado/szja/A_szemelyi_kedvezmeny20190130.html' target='_blank'>NAV: személyi kedvezmények</a>",
                "A kedvezmény együttesen érvényesíthető összege a házasságkötést követő hónaptól (ez az első jogosultsági hónap), legfeljebb 24 hónapig, jogosultsági hónaponként 33.335 Ft. Ez azt jelenti, hogy havonta ténylegesen 5000 Ft-tal kevesebb személyi jövedelemadót fizetnek a házastársak. Az 5000 Ft-os kedvezményt meg is oszthatják egymás között, de igénybe veheti a teljes kedvezményt a házastársak egyike is. <br><br>További info: <a href='https://www.jogpontok.hu/kiadvanyok/Elso_hazasok_kedvezmenye.pdf' target='_blank'>Első házasok kedvezménye</a>",
                "Vannak velem egy háztartásban élő eltartott kiskorúak illetve oktatásban részt vevők.<br><br>További info: <a href='https://www.jogpontok.hu/kiadvanyok/Csaladi_ado_es_jarulekkedvezmeny_SZJA.pdf' target='_blank'>Jogpontok.hu</a>",
                "A kedvezményezett eltartott, a „kedvezményezett eltartottnak” nem minősülő vér szerinti, örökbe fogadott vagy nevelt gyermek, aki az igénylő háztartásában él, és közoktatási intézmény tanulója vagy felsőoktatási intézményben első felsőfokú szakképzésben, első alapképzésben, első mesterképzésben vagy első egységes, osztatlan képzésben részt vevő hallgató és rendszeres jövedelemmel nem rendelkezik.",
                "Akire tekintettel családi pótlékra jogosult, magzat a várandósság időszakában (fogantatásának 91. napjától megszületéséig), a rokkantsági járadékban részesülő.",

            ],

            
      }
  },
  model: {
  },  
  methods:{

    InfoBtnClick(pIndex)
    {
        let pHeight = "340";
        let pWidth = "400";

        if (pIndex == 0) { pHeight = "500"; pWidth = "500"; }
        if (pIndex == 1) { pHeight = "250"; pWidth = "500"; }
        if (pIndex == 2) { pHeight = "250"; pWidth = "500"; }
        if (pIndex == 3) { pHeight = "500"; pWidth = "500"; }
        if (pIndex == 5) { pHeight = "400"; pWidth = "500"; }
        if (pIndex == 9) { pHeight = "400"; pWidth = "500"; }

        this.ShowInfoDialog(this.INFOLIST[pIndex], pHeight, pWidth);
    },

    SetPopupRef(pRef)
    {
        gPopupControlName = pRef;
    },

    scrollToTop() { window.scrollTo(0,0); },

    GetTextBookItem(pCompName)
    {
        return grcmain_GetTextBookItem("frmKalkulator", pCompName);
    },

    SetControlToFocus(pNextComp)
    {
        if (pNextComp == "") { return; }


        this.$refs[pNextComp].SetFocus();
    },

    banner_click()
    {
        window.open("https://premiumegeszsegpenztar.hu/landing/ep_tamogatas");
    },


    SetLang()
    {
        this.title = "Átalányadó kalkulátor";

        this.Init();
    },

    btnKerdoiv_click()
    {
        document.location = "https://premiumegeszsegpenztar.hu/landing/atalanyado-kerdoiv";
    },

    async btnKuldes_click()
    {
        if (grcmain_IsValidEmailAddress(this.$refs.EmailCim.GetText()) == false)
        {
            if (this.$refs.EmailCim.GetText() == "")
            {
                this.ShowInfoDialog("Kérjük add meg az e-mail címed!", "150", "400");   
            }
            else
            {
                this.ShowInfoDialog("Az e-mail cím formátuma helytelen!", "150", "400");   
            }
            return;
        }

        if (this.$refs.Mobil.GetText() == "")
        {
            this.ShowInfoDialog("Kérjük add meg a mobil telefonszámod!", "150", "400");   
            return;
        }

        if (this.$refs.chkSend_Hozzajarulas.GetValue() == 0)
        {
            this.ShowInfoDialog("Kérjük fogadd el az adatkezelési hozzájárulást!", "150", "400");   
            return;
        }

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            sEmailCim: this.$refs.EmailCim.GetText(),
            sMobil: this.$refs.Mobil.GetText(),
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Save", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            }
            return;
        }

       this.scrollToTop();
       this.innerformid = 3;

       //gApp.SendTagManagerEvent("kalk_kuldes_click");

       this.$refs.GRCDB.HideLoading();

    },

    chkCsaladiAdokedvezmeny_click()
    {
        this.IsChecked_chkCSAK = (this.$refs.chkCsaladiAdokedvezmeny.GetValue()==1);
    },


    async DisplaySzamitas(pIndex)
    {
        let s = "<table style='width:100%;' cellspacing='0' cellpadding='0'>";

        if (pIndex == 1)
        {
            for(let i=0; i<this.T1.length; i++)
            {
                s = s + "<tr><td style='padding:8px 4px 8px 0px; border-bottom: dotted 1px #ccc;'>"+this.T1[i].Szoveg+"</td>";
                s = s + "<td style='width:150px; text-align:right; padding-right:0px; border-bottom: dotted 1px #ccc;'>"+this.T1[i].Ertek+"</td></tr>";
            }
            s = s + "</table>";
        }
        

        if (pIndex == 2)
        {
            for(let i=0; i<this.T2.length; i++)
            {
                s = s + "<tr><td style='padding:8px 4px 8px 0px; border-bottom: dotted 1px #ccc;'>"+this.T2[i].Szoveg+"</td>";
                s = s + "<td style='width:150px; text-align:right; padding-right:0px; border-bottom: dotted 1px #ccc;'>"+this.T2[i].Ertek+"</td></tr>";
            }
            s = s + "</table>";
        }
        
        this.ShowInfoDialog(s, "700", "650");
    },


    async Init()
    {
        this.InfoText = "";

        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Init", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            }
            return;
        }

        this.STATUSZOK = Q.STATUSZOK;
        this.VEGZETTSEG = Q.VEGZETTSEG;
        this.KOLTSEG = Q.KOLTSEG;

        this.$refs.STATUSZ.SetDataSource(this.STATUSZOK);
        this.$refs.STATUSZ.SetValue(0);

        this.$refs.VEGZETTSEG.SetDataSource(Q.VEGZETTSEG);
        this.$refs.VEGZETTSEG.SetValue(0);

        this.$refs.KOLTSEG.SetDataSource(this.KOLTSEG);
        this.$refs.KOLTSEG.SetValue(this.KOLTSEG[0].id);

        this.$refs.GRCDB.HideLoading();
        
    },

    btnVissza_click()
    {
        this.scrollToTop();
        this.innerformid = 1;
    },

      HideErrors()
      {
        //this.$refs.ErrorBox.HideError();
        this.$refs.STATUSZ.HideError();
        this.$refs.VEGZETTSEG.HideError();
        this.$refs.txtSzuletesiDatum.HideError();
        this.$refs.txtEvesBevetel.HideError();
        this.$refs.txtVarhatoKoltseg.HideError();
        this.$refs.txtAnyagKoltseg.HideError();

      },

    async btnSzamol_click()
    {
        //this.HideErrors();

        let ErrList = "";


        var ErrorCompName = "";

        if (this.$refs.STATUSZ.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "STATUSZ"; }
            ErrList = ErrList + "A státusz megadása kötelező!<br>";
            //this.$refs.STATUSZ.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.VEGZETTSEG.GetValue() == 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "VEGZETTSEG"; }
            ErrList = ErrList + "A végzettség megadása kötelező!<br>";
            //this.$refs.VEGZETTSEG.ShowError(grcmain_GetTextBookItem("tech", "field_required"));
        }

        if (this.$refs.txtSzuletesiDatum.IsValid(false) == false)
        {
            if (ErrorCompName == "") { ErrorCompName = "txtSzuletesiDatum"; }
            ErrList = ErrList + "A születési idő nincs megadva vagy helytelen!<br>";
            //this.$refs.txtSzuletesiDatum.ShowError("A születési idő nincs megadva vagy helytelen!");
        }

        if (this.$refs.txtEvesBevetel.GetValue() < 1)
        {
            if (ErrorCompName == "") { ErrorCompName = "txtEvesBevetel"; }
            ErrList = ErrList + "Az éves bevétel megadása kötelező, értéke pozitív egész szám lehet!<br>";
            //this.$refs.txtEvesBevetel.ShowError("A mező kitöltése kötelező, értéke pozitív egész szám lehet!");
        }

        if (this.$refs.txtVarhatoKoltseg.GetValue() < 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "txtVarhatoKoltseg"; }
            ErrList = ErrList + "A várható összes költség értéke pozitív egész szám lehet!<br>";
            //this.$refs.txtVarhatoKoltseg.ShowError("A mező kitöltése kötelező, értéke pozitív egész szám lehet!");
        }
        else
        {
            if (this.$refs.txtVarhatoKoltseg.GetValue() > this.$refs.txtEvesBevetel.GetValue())
            {
                if (ErrorCompName == "") { ErrorCompName = "txtVarhatoKoltseg"; }
                ErrList = ErrList + "A várható költség nem lehet nagyobb az éves bevételnél!<br>";
                //this.$refs.txtVarhatoKoltseg.ShowError("A mező értéke nem lehet nagyobb az éves bevételnél!");
            }
        }

        if (this.$refs.txtAnyagKoltseg.GetValue() < 0)
        {
            if (ErrorCompName == "") { ErrorCompName = "txtAnyagKoltseg"; }
            ErrList = ErrList + "Az anyag, áru és alvállalkozók költsége pozitív egész szám lehet!<br>";
            //this.$refs.txtAnyagKoltseg.ShowError("A mező értéke pozitív egész szám lehet!");
        }
        else
        {
            if (this.$refs.txtAnyagKoltseg.GetValue() > this.$refs.txtVarhatoKoltseg.GetValue())
            {
                if (ErrorCompName == "") { ErrorCompName = "txtAnyagKoltseg"; }
                ErrList = ErrList + "Az anyag, áru és alvállalkozók költsége nem lehet nagyobb a várható költségnél!<br>";
                //this.$refs.txtAnyagKoltseg.ShowError("A mező értéke nem lehet nagyobb a teljes várható költségnél!");
            }
        }

       if (this.IsChecked_chkCSAK)
       {
            if ((this.$refs.txtEltartott.GetValue() < 0) || (this.$refs.txtKedvezmenyezettEltartott.GetValue() < 0))
            {
                if (ErrorCompName == "") { ErrorCompName = "txtEltartott"; }
                ErrList = ErrList + "Kérem ellenőrizze az eltartottak számát! A szám nem lehet kisebb 0-nál!<br>";
            }

            if (this.$refs.txtEltartott.GetValue() < this.$refs.txtKedvezmenyezettEltartott.GetValue())
            {
                if (ErrorCompName == "") { ErrorCompName = "txtKedvezmenyezettEltartott"; }
                ErrList = ErrList + "Az eltartottak száma nem lehet kisebb a kedvezményezett eltartottak számánál!<br>";
            }
       }

        if (grcmain_IsValidEmailAddress(this.$refs.EmailCim.GetText()) == false)
        {
            if (this.$refs.EmailCim.GetText() == "")
            {
                this.ShowInfoDialog("Kérjük add meg az e-mail címed!", "150", "400");   
            }
            else
            {
                this.ShowInfoDialog("Az e-mail cím formátuma helytelen!", "150", "400");   
            }
            return;
        }

        /*
        if (this.$refs.Mobil.GetText() == "")
        {
            this.ShowInfoDialog("Kérjük add meg a mobil telefonszámod!", "150", "400");   
            return;
        }
        */

        if (this.$refs.chkSend_Hozzajarulas.GetValue() == 0)
        {
            this.ShowInfoDialog("Kérjük fogadd el az adatkezelési hozzájárulást!", "150", "400");   
            return;
        }


        if (ErrorCompName != "")
        {
          //this.SetControlToFocus(ErrorCompName);

          this.ShowInfoDialog(ErrList, "300", "400");
          return;
        }

        let pCSAK = this.$refs.chkCsaladiAdokedvezmeny.GetValue();
        let pCSAK_Eltartott = 0;
        let pCSAK_Kedvezmenyezett = 0;
        if (pCSAK == 1)
        {
            pCSAK_Eltartott = this.$refs.txtEltartott.GetValue();
            pCSAK_Kedvezmenyezett = this.$refs.txtKedvezmenyezettEltartott.GetValue();
        }


        this.$refs.GRCDB.ShowLoading(false);
        
        var QP = {
            iStatuszID: this.$refs.STATUSZ.GetValue(),
            iVegzettsegID: this.$refs.VEGZETTSEG.GetValue(),
            iEvesBevetel: this.$refs.txtEvesBevetel.GetValue(),
            iKoltsegID: this.$refs.KOLTSEG.GetValue(),
            iVarhatoKoltseg: this.$refs.txtVarhatoKoltseg.GetValue(),
            iAnyagKoltseg: this.$refs.txtAnyagKoltseg.GetValue(),
            iMasForrasJovedelem: this.$refs.txtMasForrasJovedelem.GetValue(),
            sSzuletesiDatum: this.$refs.txtSzuletesiDatum.GetText(),
            iSzemelyiKedvezmeny: this.$refs.chkSzemelyiKedvemzeny.GetValue(),
            iElsoHazas: this.$refs.chkElsoHazasKedvezmeny.GetValue(),
            iCSAK: pCSAK,
            iCSAK_Eltartott: pCSAK_Eltartott,
            iCSAK_Kedvezmenyezett: pCSAK_Kedvezmenyezett,
            sEmailCim: this.$refs.EmailCim.GetText(),
            sMobil: this.$refs.Mobil.GetText(),

        };
        var Q;
        await this.$refs.GRCDB.GetData(this.WSPREFIX+"_Szamitas", QP).then(res => { Q = res; });

        if (Q.APPERR[0].ERR != "")
        {
            this.$refs.GRCDB.HideLoading();
            if (Q.APPERR[0].ERR.startsWith("APPVER_ERROR"))
            {
                this.$emit("handlecommerror", Q.APPERR[0].ERR);
            }
            else
            {            
                this.ShowInfoDialog(Q.APPERR[0].ERR, "200", "400");
            }
            return;
        }

        this.T1 = Q.T1;
        this.T2 = Q.T2;
        this.TSUM = Q.TSUM;
        this.TSZJA = Q.TSZJA;
        this.MaradtSZJA = Q.MISC[0].MaradtSZJA;
        this.SzjaInfoSzoveg = Q.MISC[0].SzjaInfoSzoveg;

       this.scrollToTop();
       this.innerformid = 2;

       this.$refs.GRCDB.HideLoading();


    },


    async ShowInfoDialog(pText, pHeight, pWidth)
    {
        var DialogResult = "";
        var p = grccomp_dialog_alert_GetDefaults(grcmain_GetTextBookItem("tech", "informacio"), pText);             
        p.height = pHeight;
        p.width = pWidth;
        p.padding_top = -1;
        if (grccomp_getScreenSize().width < 400) { p.width = 300; }
        await this.$refs.Dialog.ShowDialog(p).then(res => 
        { 
            DialogResult = res; 
        });               
    },



  },

  created()
  {

  },

  mounted()
  {
    gForm = this;
    gPopupControlName = "";

    if (gAppInitDone)
    {
      this.SetLang();
    }
  }

}


</script>


<style scoped>

.maintitle
{
    width: 100%;
    box-sizing: border-box;
    color:#fff;
    font-family: "PremiumDefault";
    font-size:22px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px;
}

.main_col_cont
{
    width:100%;
    box-sizing: border-box;
}

.main_col
{
    width:100%;
    box-sizing: border-box;
    display:inline-block;
    vertical-align: top;
}

.main_col_left
{
    width:20%;
    padding:8px;
}

.main_col_middle
{
    width:70%;
}

.main_col_right
{
    width:30%;
    padding:11px 8px;
}

.banner_img
{
    width:100%;
    border-radius:7px;
    cursor:pointer;
}


.innerform
{
    width:100%;
    box-sizing: border-box;
    /* max-width: 700px; */
    margin:0px auto;
    border: solid 0px #ccc;
    padding: 0px;
    border-radius: 16px;    
    box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);
    -webkit-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);
    -moz-box-shadow: 0px 0px 15px 0px rgba(0,0,0,0.25);    
}

.field_label
{
    color: #222;
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 8px 0px;
    display: inline-block;
    box-sizing: border-box;    
}

.infotext
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:16px;
    line-height: 22px;
    font-weight:normal;
    text-align: justify;
    padding: 0px 10px 0px 20px;
}

.chkHozzajarulas
{
    color: #222;
    font-family: "PremiumDefault";
    font-size:14px;
    line-height: 18px;
    font-weight:normal;
    text-align: justify;
}

div >>> .info_title
{
    width: 100%;
    box-sizing: border-box;
    color: var(--premblue);
    font-family: "PremiumDefault";
    font-size:18px;
    line-height: 22px;
    font-weight:normal;
    text-align: left;
    padding: 10px 0px;
    font-weight: 500;
}


.btn_cont
{
  width:100%;
  box-sizing: border-box;
  padding:4px 0px;
  border-top:solid 0px #ccc;
  margin-top: 10px;
  text-align: center;
}

.btn
{
  display: inline-block;
  font-size: 16px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:dodgerblue;
  color:#fff;
  cursor:pointer;
  border-radius: 5px;
  margin: 2px;
  min-width: 120px;
  padding: 14px 8px 12px 8px;
}

.btn_gray2
{
  background-color: #ccc;
  color:#222;
}

.btn:hover
{
    opacity:0.9;
}

.btn_icon
{
    margin-right:4px;
}

.btn_text
{
    display:inline;
}

.btn_gray
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.btn_gray:hover
{
  background-color: #ccc;
  color:#fff;
  cursor: default;
  opacity: 0;
}

.field_input
{
    width:120px;
    padding:4px 0px;
    padding-right: 8px;
}

.infobtn
{
    font-size:16px;
    line-height:16px;
    cursor:pointer;
    color:dodgerblue;
}

.infobtn:hover
{
    opacity:0.9;
}

.btn_cont2
{
    width:100%;
    box-sizing: border-box;
    text-align: center;
    max-width: 400px;
    margin:0px auto;
}

.btn2
{
  display: inline-block;
  font-size: 14px;
  line-height: 16px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  background-color:dodgerblue;
  color:#fff;
  cursor:pointer;
  border-radius: 5px;
  margin: 10px;
  width: 120px;
  padding: 14px 8px 12px 8px;
  text-decoration: none;
  vertical-align: top;
}

.btn2:visited
{
    text-decoration: none;
}

.btn2_ep
{
    background-color: var(--premblue);
}

.btn2_nyp
{
    background-color: dodgerblue;
}

.btn2:hover
{
    opacity:0.9;
}

.CalcResult
{
    width:100%;
    box-sizing: border-box;
  font-size: 14px;
  line-height: 20px;
  font-family: 'PremiumDefault';
  font-weight: normal;
  text-align: center;  
  color:royalblue;
  padding: 12px 8px;
  text-transform: uppercase;
}

.szabaly_info_ikon
{
    width:30px;
    text-align:right;
    font-size:26px;
    line-height:26px;    
    cursor: pointer;
    color:dodgerblue;
}

.szabaly_info_ikon:hover
{
    opacity: 0.9;
}

.main_col_banner_top
{
    width:100%;
    box-sizing:border-box;
    display:none;
}

.main_col_banner_top_item
{
    width:50%;
    box-sizing: border-box;
    padding:4px;
    display:inline-block
}


@media (max-width:900px)
{
    .infotext
    {
        font-size:14px;
        line-height: 18px;
    }

}

@media (max-width:700px)
{
    .main_col
    {
        width:100%;
    }

    .infotext
    {
        font-size:14px;
        line-height: 18px;
        padding: 30px 0px 20px 0px;
    }

    .field_label
    {
        font-size:14px;
        line-height: 18px;
    }


    .main_col_middle
    {
        width:100%;
    }

    .main_col_right
    {
        width:100%;
        padding:8px 0px;
        display:none;
    }

    .main_col_banner_top
    {
        display:inline-block;
    }

}

@media (max-width:500px)
{
    .main_col_banner_top_item
    {
        display:inline-block;
        width:100%;
        padding:4px 0px;
    }

}

</style>